import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * AdminProtectedRoute — requires authenticated user with is_admin === true.
 * Non-admin authenticated users are redirected back to /dashboard.
 * Unauthenticated users go to /admin/login.
 */
const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, booting } = useAuth();
  const location = useLocation();

  if (booting) {
    return (
      <div
        className="min-h-screen w-full flex items-center justify-center bg-bg-primary"
        data-testid="admin-booting"
      >
        <div className="flex flex-col items-center gap-3 text-text-secondary">
          <div className="h-8 w-8 rounded-full border-2 border-danger border-t-transparent animate-spin" />
          <div className="text-[13px]">Verifying admin access…</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    // A regular user should not sit on admin routes.
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
